'use strict';
var novicell = novicell || {}; // eslint-disable-line
novicell.emailValidation =
  novicell.emailValidation ||
  new (function () {
    this.init = function () {
      let emailValidationGroups = document.querySelectorAll(
        '.ef-email-validation'
      );

      if (!emailValidationGroups) {
        return;
      }
      emailValidationGroups.forEach((group) => {
        const model = group.dataset.model;
        const modelField = document.querySelector(`#${model}`);
        if (!modelField) {
          return;
        }
        const fields = group.querySelectorAll('input');
        fields[0].focus();
        const values = Array(6);
        let validationCode = '';
        fields.forEach((ele, index) => {
          ele.addEventListener('keydown', (e) => {
            // if the keycode is backspace & the current field is empty
            // focus the input before the current. Then the event happens
            // which will clear the "before" input box.
            if (e.keyCode === 8 && !e.target.value)
              fields[Math.max(0, index - 1)].focus();
          });
          ele.addEventListener('input', (e) => {
            // // take the first character of the input
            // // this actually breaks if you input an emoji like 👨‍👩‍👧‍👦....
            // // but I'm willing to overlook insane security code practices.
            const [first, ...rest] = e.target.value;

            e.target.value = first ? first : ''; // first will be undefined when backspace was entered, so set the input to ""
            values[index] = first;
            validationCode = values.join('');
            modelField.value = validationCode;
            const lastInputBox = index === fields.length - 1;
            const didInsertContent = first !== undefined;
            if (didInsertContent && !lastInputBox) {
              // continue to input the rest of the string
              fields[index + 1].focus();
              if (rest.length) {
                fields[index + 1].value = rest.join('');
                fields[index + 1].dispatchEvent(new Event('input'));
              }
            }
          });
        });
      });
    };
  })();
